<div class="es-invoice-body-section" [ngClass]="{ 'is-valid': isDetailsValid }">
  <header>
    <span *ngIf="isDetailsValid">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.0757 16.7728L6.17573 12.8728C5.94142 12.6385 5.94142 12.2586 6.17573 12.0243L7.02424 11.1757C7.25854 10.9414 7.63846 10.9414 7.87277 11.1757L10.5 13.8029L16.1272 8.17573C16.3615 7.94142 16.7415 7.94142 16.9758 8.17573L17.8243 9.02426C18.0586 9.25857 18.0586 9.63846 17.8243 9.87279L10.9243 16.7728C10.6899 17.0071 10.31 17.0071 10.0757 16.7728Z"
          fill="currentColor"
        />
      </svg>
    </span>

    <h3>{{ "LABELS.COMMERCIAL_INVOICE_DETAILS" | translate }}</h3>
  </header>
  <div class="es-invoice-body-section-body">
    <form [formGroup]="fg" autocomplete="off">
      <div class="form-row">
        <div class="col-3">
          <app-control-wrapper [control]="fg.get('invoiceNumber')" [errors]="errors">
            <label control-label [for]="'invoiceNumber-' + billOfLadingId">{{ "LABELS.INVOICE_NUMBER" | translate }}</label>
            <input
              control-wrapper
              class="form-control"
              formControlName="invoiceNumber"
              [id]="'invoiceNumber-' + billOfLadingId"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [mask]="'F{17}'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
              [maxMaskLength]="17"
              type="text"
            />
          </app-control-wrapper>
        </div>
        <div class="col-7">
          <auto-select
            [isShowHelper]="false"
            [fc]="fg.get('countryOfExportId')"
            [id]="'countryOfExport'"
            [bindValue]="'id'"
            [bindLabel]="['code', 'description']"
            [clearable]="true"
            [label]="'LABELS.COUNTRY_OF_EXPORT'"
            [initializeItems]="initCountryOfExportItems"
            [change]="getCountries()"
            [helper]="'FORM_HELPER.COUNTRY_OF_EXPORT'"
            (update)="onCountryOfExportChange($event)"
          ></auto-select>
        </div>
        <div class="col-2">
          <app-control-wrapper [control]="fg.get('currency')" [errors]="errors">
            <label control-label [for]="'currency-' + billOfLadingId">{{ "LABELS.CURRENCY" | translate }}</label>
            <ng-select
              class="custom"
              [id]="'currency-' + billOfLadingId"
              [formControl]="fg.get('currency')"
              [items]="currencies"
              [bindLabel]="'code'"
              [bindValue]="'code'"
              [clearable]="false"
              control-wrapper
            ></ng-select>
          </app-control-wrapper>
        </div>
        <div class="col-12" *ngIf="fg.get('currency').value !== DEFAULT_CURRENCY_CODE">
          <div class="form-group">
            <label>{{ "LABELS.RATE" | translate }}</label>
            <div class="form-control pl-0 border-unset control-rate">{{ currencyHasRateError ? "" : currencyRate }}</div>
          </div>
        </div>
        <div class="col-12">
          <app-control-wrapper [control]="fg.get('incoTermsCode')" [errors]="errors">
            <label control-label [for]="'incoterms-' + billOfLadingId">
              {{ "LABELS.INCOTERMS" | translate }} {{ "FORM_LABEL.OPTIONAL" | translate }}
            </label>
            <ng-select
              class="custom"
              [id]="'incoterms-' + billOfLadingId"
              [formControl]="fg.get('incoTermsCode')"
              [items]="incoterms"
              bindValue="code"
              [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
              control-wrapper
              [searchFn]="searchInvoice"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.code + " " + item.name }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.code + " " + item.name }}
              </ng-template>
            </ng-select>
          </app-control-wrapper>
        </div>
      </div>
    </form>
  </div>
</div>
